export const APP_LOCALE = 'es-CO';
export const APP_CURRENCY = 'COP';
